import React from 'react';
import './Beli.css';
import Cart from './Cart';
import axios from 'axios';
import { ToastContainer, toast, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CurrencyFormat from 'react-currency-format';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

const maxItemConst = 40;

class Beli extends React.Component {
  constructor(props) {
    super(props);
    this.state ={
      products: [],
      initialProducts:[],
      cartProducts:[],
      count:0,
      category:'semua',
      maxItem: maxItemConst 
    }

    this.onCountAdd = this.onCountAdd.bind(this);
    this.handleSearchInput = this.handleSearchInput.bind(this);
    this.submithandleSearchInput = this.submithandleSearchInput.bind(this);
  }

  componentDidMount() {
    axios.get(`https://api-ls.faisalhakim.com/public/api/products`)
    .then(res => {
      const products = res.data;
      this.setState({ 
        products:products,
        initialProducts:products 
      });
    })

    if(localStorage.getItem('count')){
      this.setState ({
        count: this.state.count + parseInt(localStorage.getItem('count'), 10)
      })
    }
    if(localStorage.getItem('cartProducts')){
      this.setState({
        cartProducts: JSON.parse(localStorage.getItem('cartProducts'))
      })
    }
    window.scrollTo(0, 0)
  }

  onCountAdd(e,newelement) {
    if (this.state.cartProducts.find((e) => e.id === newelement.id) === undefined) {
      this.setState ({
        count: this.state.count+1
      })
      this.setState({
        cartProducts: [...this.state.cartProducts, newelement]
      })
    } else {
      toast.success("Product tersebut sudah ada di Keranjang")
    }
  }

  handleSearchInput(e) {
    var searchText = e.target.value;
    var filteredItems = this.state.initialProducts.filter(function(item) {
        return item.title.toLowerCase().search(searchText.toLowerCase()) > -1;
    });
    
    if(e.key.toLowerCase() === 'enter') {
      this.setState({ products: filteredItems });
      e.preventDefault();
      e.target.blur()
    }
  }

  submithandleSearchInput() {
    var searchText = document.getElementsByClassName("cariProduct")[0].value;
    var filteredItems = this.state.initialProducts.filter(function(item) {
        return item.title.toLowerCase().search(searchText.toLowerCase()) > -1;
    });
    this.setState({ products: filteredItems });
  }


    render () {
      return (
        
        <div className="beli jumbotron jumbotron-fluid">

            <div className="container">
              <h1>Beli</h1>
              <div className="row">
              <div className="col-lg-12 col-12 mx-auto">
                    <ul className="nav nav-tabs">
                        <li className="nav-item mx-auto">
                            <a className="nav-link active show" data-toggle="tab" href="#tab-1" onClick={() => {this.setState({ products: this.state.initialProducts, category: 'semua', maxItem : maxItemConst }); document.getElementsByClassName("cariProduct")[0].value = ''}}>Semua</a>
                        </li>
                        <li className="nav-item mx-auto">
                            <a className="nav-link" data-toggle="tab" href="#tab-2" onClick={() => {this.setState({ products: this.state.initialProducts, category: 'sayuran', maxItem : maxItemConst }); document.getElementsByClassName("cariProduct")[0].value = ''}}>Sayuran</a>
                        </li>
                        <li className="nav-item mx-auto">
                            <a className="nav-link" data-toggle="tab" href="#tab-3" onClick={() => {this.setState({ products: this.state.initialProducts, category: 'daging', maxItem : maxItemConst }); document.getElementsByClassName("cariProduct")[0].value = ''}}>Daging</a>
                        </li>
                        <li className="nav-item mx-auto">
                            <a className="nav-link" data-toggle="tab" href="#tab-4" onClick={() => {this.setState({ products: this.state.initialProducts, category: 'bumbu', maxItem : maxItemConst }); document.getElementsByClassName("cariProduct")[0].value = ''}}>Bumbu</a>
                        </li>
                        <li className="nav-item mx-auto">
                            <a className="nav-link" data-toggle="tab" href="#tab-5" onClick={() => {this.setState({ products: this.state.initialProducts,category: 'buah', maxItem : maxItemConst }); document.getElementsByClassName("cariProduct")[0].value = ''}}>Buah</a>
                        </li>
                    </ul>
                </div>
                <div style={{width:100+"%"}}>
                    <div className="tab-content">
                      <div className="input-group filter">
                        <input className="form-control cariProduct mx-auto" onKeyDown={this.handleSearchInput} type="text" placeholder="Cari product disini.."  aria-describedby="basic-addon2"/>
                        <div className="input-group-append">
                          <button className="btn" type="button" onClick={this.submithandleSearchInput}><i className="fa fa-search" aria-hidden="true"></i></button>
                        </div>
                      </div>
                      <div>
                          <div className="row">
                            {this.state.products
                            .filter((e) => this.state.category === 'semua' ? (e) => e.availability === "1" : this.state.category === 'sayuran' ? e.category.toLowerCase() === 'sayuran' && e.availability === "1" : this.state.category === 'daging' ? e.category.toLowerCase() === 'daging' && e.availability === "1" : this.state.category === 'bumbu' ? e.category.toLowerCase() === 'bumbu' && e.availability === "1" : e.category.toLowerCase() === 'buah' && e.availability === "1")
                            .slice(0,this.state.maxItem)
                            .map(
                              (products,index) => 
                              <div className="col-lg-3 col-md-4 col-sm-4 col-6 d-flex align-items-stretch mx-auto" key={products.id}>
                                <div className="card" >
                                  <LazyLoadImage effect="blur" className="card-img-top img-fluid rounded shadow"  src={"https://api-ls.faisalhakim.com/public/api/image/"+products.filename} data-toggle="modal" data-target={"#"+(products.title+'a'+products.id).replace(/ /g,'')} onError={(e)=>{e.target.onerror = null;e.target.src="https://api-ls.faisalhakim.com/public/api/image/"+products.filename}} alt="Refresh jika gambar tidak muncul"/>
                                  <div className="card-body">
                                    <h5 className="text-left" data-toggle="modal" data-target={"#"+(products.title+'a'+products.id).replace(/ /g,'')} title={products.title}>{products.title.length > 20 ? products.title.substring(0, 20)+'...': products.title}</h5>
                                    <p className="card-text text-left">
                                      <CurrencyFormat value={parseInt(products.price.match(/\d/g).join(""))} displayType={'text'} thousandSeparator={true} prefix={'Rp.'} /><small className="font-weight-light">{" / "+products.description}</small>
                                      {products.priceChanges === "1" ? <small className="font-weight-light font-italic"><br/><br/>*Harga dapat berubah sewaktu-waktu</small> : ""}
                                    </p>
                                  </div>
                                  <button type="button" className="btn btn-sm btnAdd" onClick={(e) => this.onCountAdd(e,products)}>Masuk Keranjang</button>
                                </div>
                                <div className="modal fade" id={(products.title+'a'+products.id).replace(/ /g,'')} role="dialog">
                                  <div className="modal-dialog modal-lg">
                                    <div className="modal-content">
                                      <div className="modal-header mx-auto">
                                        <h4 className="modal-title">Product Detail</h4>
                                      </div>
                                      <div className="modal-body">
                                        <LazyLoadImage effect="blur" className="card-img-top img-fluid img-modal rounded"  src={"https://api-ls.faisalhakim.com/public/api/image/"+products.filename}  onError={(e)=>{e.target.onerror = null; e.target.src="https://api-ls.faisalhakim.com/public/api/image/"+products.filename}} alt=""/>
                                        <div className="card-text text-left px-5 m-auto">
                                          <h2>{products.title}</h2>
                                          <p>
                                            <CurrencyFormat value={parseInt(products.price.match(/\d/g).join(""))} displayType={'text'} thousandSeparator={true} prefix={'Rp.'} /><small className="font-weight-light">{" / "+products.description}</small>
                                            {products.priceChanges === "1" ? <small className="font-weight-light font-italic"><br/>*Harga dapat berubah sewaktu-waktu</small> : ""}
                                          </p>
                                        </div>
                                      </div>
                                      <div className="modal-footer">
                                        <button type="button" className="btn btn-sm mx-auto" onClick={(e) => this.onCountAdd(e,products)}>Masuk Keranjang</button>
                                        <button type="button" className="btn btn-sm mx-auto btn-close-modal" data-dismiss="modal">Close</button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                      </div>
                    </div>
                </div>
                <div className="text-center m-auto">
                  {this.state.maxItem < this.state.products.filter((e) => this.state.category === 'semua' ? (e) => e.availability === "1" : this.state.category === 'sayuran' ? e.category.toLowerCase() === 'sayuran' && e.availability === "1" : this.state.category === 'daging' ? e.category.toLowerCase() === 'daging' && e.availability === "1" : this.state.category === 'bumbu' ? e.category.toLowerCase() === 'bumbu' && e.availability === "1" : e.category.toLowerCase() === 'buah' && e.availability === "1").length ? <button type="button" className="btn shadow btnLoad" onClick={() => this.setState({maxItem: this.state.maxItem + maxItemConst})}>Tampilkan lebih banyak</button> : ""}
                </div>
              </div>
            </div>
            <Cart count={this.state.count} cartProducts={this.state.cartProducts}/> 
            <ToastContainer
              position="top-center"
              transition={Slide}
              autoClose={2000}
              hideProgressBar
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover={false}
            />
        </div>
      );
    }
  }


export default Beli;
